export default __webpack_public_path__ + "static/media/moldura-2-NOVO-site.247db0d8.mp4";